// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardAmount,
.empty-data {
  background: var(--foreground-secondary);
  border-radius: 7px !important;
  margin: 13px 0 0;
}

.dashboard-balace-container {
  border: 0.1px solid rgb(4, 84, 170);
  border-radius: 5px;
  margin: 10px;
}

.row.performance {
  display: flex;
  flex-wrap: wrap;
}

.row.performance > div[class*=col-] {
  padding: 8px;
  margin-bottom: 0 !important; /* remove vertical gaps */
}

[cdkDropList] {
  display: flex;
  flex-wrap: wrap;
}

[cdkDrag] {
  transition: transform 0.25s ease;
  min-height: 350px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/landing-page/landing-page.component.scss"],"names":[],"mappings":"AAAA;;EAEE,uCAAA;EACA,6BAAA;EACA,gBAAA;AACF;;AAEA;EACE,mCAAA;EACA,kBAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,eAAA;AAEF;;AAGA;EACE,YAAA;EACA,2BAAA,EAAA,yBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;AAAF;;AAGA;EACE,gCAAA;EACA,iBAAA;AAAF","sourcesContent":[".dashboardAmount,\n.empty-data {\n  background: var(--foreground-secondary);\n  border-radius: 7px !important;\n  margin: 13px 0 0;\n}\n\n.dashboard-balace-container {\n  border: 0.1px solid rgb(4, 84, 170);\n  border-radius: 5px;\n  margin: 10px;\n}\n.row.performance {\n  display: flex;\n  flex-wrap: wrap;\n  // margin: -20px -8px;\n  //   margin: -20px 0px 0px 0px;\n}\n\n.row.performance > div[class*='col-'] {\n  padding: 8px;\n  margin-bottom: 0 !important; /* remove vertical gaps */\n}\n\n[cdkDropList] {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n[cdkDrag] {\n  transition: transform 0.25s ease;\n  min-height: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
